import { Link } from "react-router-dom";

const Features = () => {
  return (
    <>
      <div className="ail-work-area pt-50 pb-50" id="capabilities">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-9">
              <div className="text-center mb-30">
                <p className="ail-sub-title text-black fw-500 ah-input-bg d-inline-flex align-items-center gap-2 rounded-5 mb-20">
                  <span className="ail-gd-bg"></span> Powerful Capabilities
                </p>
                <h2 className="ail-title text-black fs-48 fw-600">
                  Discover the Core Features <br />
                  <span className="ail-highlighted-text">
                    That Power Your Garage
                  </span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h3 className="text-black fs-36">Hassel-free Workflows</h3>
              <ul className="ail-work-list list-unstyled">
                <li className="d-flex gap-3">
                  <svg
                    className="mt-5-ov"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.3"
                      d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                      fill="#6672FB"
                    />
                    <path
                      d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                      fill="#476EFB"
                    />
                  </svg>
                  <div className="ail-work__content">
                    <p className="text-black fw-700 mb-0">
                      Instant Estimates That Build Trust
                    </p>
                    <p className="fch-50 mb-0">
                      Create accurate, professional repair estimates in just a
                      few clicks. Include labour, parts, and tax details for
                      full transparency. Easily convert estimates into job cards
                      or invoices to streamline workflows, save time, and boost
                      customer trust.
                    </p>
                  </div>
                </li>
                <li className="d-flex gap-3 mt-20">
                  <svg
                    className="mt-5-ov"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.3"
                      d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                      fill="#6672FB"
                    />
                    <path
                      d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                      fill="#476EFB"
                    />
                  </svg>
                  <div className="ail-work__content">
                    <p className="text-black fw-700 mb-0">
                      Digital Job Cards for a Modern Garage
                    </p>
                    <p className="fch-50 mb-0">
                      Create and manage job cards digitally with real-time
                      updates. Track services, parts, labour, and technician
                      assignments from one place; no paperwork, no confusion.
                      Stay organized and efficient, wherever you are.
                    </p>
                  </div>
                </li>
                <li className="d-flex gap-3 mt-20">
                  <svg
                    className="mt-5-ov"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.3"
                      d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                      fill="#6672FB"
                    />
                    <path
                      d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                      fill="#476EFB"
                    />
                  </svg>
                  <div className="ail-work__content">
                    <p className="text-black fw-700 mb-0">
                      Online Booking Made Simple for Your Customers
                    </p>
                    <p className="fch-50 mb-0">
                      Allow your customers to schedule service appointments
                      online anytime with ease. Our online booking system offers
                      real-time availability, automated confirmations, and easy
                      rescheduling, helping you fill your garage’s schedule
                      without hassle.{" "}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="ail-gd-bg-2 p-4 pt-40 pb-40 rounded-16">
                <img
                  src="assets/wms-1.png"
                  alt=""
                  className="w-100 img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="mt-50">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="ail-gd-bg-3 p-4 pt-40 pb-40 rounded-16">
                  <img
                    src="assets/wms-2.png"
                    alt=""
                    className="w-100 img-fluid rounded-16"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="pl-40">
                  
                  <h3 className="text-black fs-36">
                    Built-In Compliance You Can Trust
                  </h3>
                  
                  <ul className="ail-work-list list-unstyled">
                    <li className="d-flex gap-3">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        />
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        />
                      </svg>
                      <div className="ail-work__content">
                        <p className="text-black fw-700 mb-0">
                          Effortless E-Invoicing for Faster Payments
                        </p>
                        <p className="fch-50 mb-0">
                          Generate and send accurate digital invoices instantly
                          with our seamless e-invoicing system. Reduce
                          paperwork, speed up billing, and improve cash flow;
                          all while ensuring compliance with tax regulations.
                          Manage invoices anytime, anywhere, right from your
                          garage management platform.
                        </p>
                      </div>
                    </li>
                    <li className="d-flex gap-3 mt-20">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        />
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        />
                      </svg>
                      <div className="ail-work__content">
                        <p className="text-black fw-700 mb-0">
                          Automated Accounting for Hassle-Free Finances
                        </p>
                        <p className="fch-50 mb-0">
                          Simplify your financial management with automated
                          accounting that tracks expenses, revenues, taxes, and
                          payments in real time. Reduce errors, save time on
                          bookkeeping, and get accurate reports, all integrated
                          seamlessly into your garage management software.{" "}
                        </p>
                      </div>
                    </li>
                    <li className="d-flex gap-3 mt-20">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        />
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        />
                      </svg>
                      <div className="ail-work__content">
                        <p className="text-black fw-700 mb-0">
                          Accurate GST-Compliant Sales Reports
                        </p>
                        <p className="fch-50 mb-0">
                          Generate detailed sales reports that fully comply with
                          GST regulations. Easily track taxable sales, input
                          credits, and tax liabilities to ensure seamless filing
                          and audit readiness—all integrated within your garage
                          management software.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-40">
            <div className="ail-main-bg p-5 rounded-16">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <h3 className="text-black fs-36">
                    Communication Made Easy and Effective
                  </h3>
                  <ul className="ail-work-list list-unstyled">
                    <li className="d-flex gap-3">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        />
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        />
                      </svg>
                      <div className="ail-work__content">
                        <p className="text-black fw-700 mb-0">
                          Real-Time Service Updates, Automatically Delivered{" "}
                        </p>
                        <p className="fch-50 mb-0">
                          Keep your customers and team in the loop with
                          automatic notifications on service progress,
                          approvals, and completions. Reduce calls and improve
                          transparency with timely updates sent directly via SMS
                          or email—effortlessly managed from your garage
                          software.{" "}
                        </p>
                      </div>
                    </li>
                    <li className="d-flex gap-3 mt-20">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        />
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        />
                      </svg>
                      <div className="ail-work__content">
                        <p className="text-black fw-700 mb-0">
                          Remind, Follow Up, Repeat; Automatically
                        </p>
                        <p className="fch-50 mb-0">
                          Automate service follow-ups, payment reminders, and
                          maintenance alerts with ease. Keep your customers
                          engaged and informed while reducing manual effort.
                          Boost repeat business and customer satisfaction.
                        </p>
                      </div>
                    </li>
                    <li className="d-flex gap-3 mt-20">
                      <svg
                        className="mt-5-ov"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.3"
                          d="M8.9998 1.80005C5.0308 1.80005 1.7998 5.03105 1.7998 9.00005C1.7998 12.969 5.0308 16.2 8.9998 16.2C12.9688 16.2 16.1998 12.969 16.1998 9.00005C16.1998 5.03105 12.9688 1.80005 8.9998 1.80005ZM7.1998 13.5L3.5998 9.90005L4.8688 8.63105L7.1998 10.953L13.1308 5.02205L14.3998 6.30005L7.1998 13.5Z"
                          fill="#6672FB"
                        />
                        <path
                          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM9 16.2C5.031 16.2 1.8 12.969 1.8 9C1.8 5.031 5.031 1.8 9 1.8C12.969 1.8 16.2 5.031 16.2 9C16.2 12.969 12.969 16.2 9 16.2ZM13.131 5.022L7.2 10.953L4.869 8.631L3.6 9.9L7.2 13.5L14.4 6.3L13.131 5.022Z"
                          fill="#476EFB"
                        />
                      </svg>
                      <div className="ail-work__content">
                        <p className="text-black fw-700 mb-0">
                          Instant Chat Support for Real-Time Assistance
                        </p>
                        <p className="fch-50 mb-0">
                          Get instant support from our team whenever you need
                          it. With built-in chat support, you can quickly
                          connect with us to resolve queries, receive guidance,
                          and ensure smooth use of the platform all in real
                          time, without leaving the system.{" "}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <div className="pl-15">
                    <div className="bg-sky-blue p-4 rounded-16">
                      <img
                        src="assets/wms-3.png"
                        alt=""
                        className="w-100 img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
